import { formatNumberWithDecimals } from '@/creditflowresearch/ui/components/deals/helpers';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { useTableDictionaries } from '@/creditflowresearch/application/TableDictionaries';

interface IMoneySizeCellProps {
  value: number | null | undefined,
  currencyId: string | null | undefined,
  decimals?: number,
  tooltipCustomContent?: (formattedValue: string) => string,
}

const MoneySizeCell = ({ value, currencyId, decimals = 3, tooltipCustomContent }: IMoneySizeCellProps) => {
  const { currencies } = useTableDictionaries();

  if (value === null || value === undefined) {
    return (<>-</>);
  }

  const formatted = formatNumberWithDecimals(value, decimals);
  const currencyLabel = currencyId ? currencies.getById(currencyId)?.abbreviation : null;
  const tooltipDefaultValue = currencyLabel ? `${ currencyLabel } ${ formatted } M` : `${ formatted } M`;

  return (
    <Tooltip content={ tooltipCustomContent ? tooltipCustomContent(tooltipDefaultValue) : tooltipDefaultValue }>
      { formatted }
    </Tooltip>
  );
};

export default MoneySizeCell;
